import { Button, Divider, FormControl, Grid, TextField, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { chain } from 'lodash'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Detail from '../components/Detail'
import IncrementingNumberInput from '../components/IncrementingNumberInput'
import { ReturnReasonSelector, ReturnReasonSelectorContextProvider } from '../components/ReturnReasonSelector'
import { OrderContext } from '../OrderContext'
import { MaterialBatchCollection } from '../OrderContext/types'
import { getDate } from '../util'

const ReturnListRow: React.FC<{ row: MaterialBatchCollection, number: number }> = ({ row, number }) => {
    const { dispatch, customer: { language } } = useContext(OrderContext)
    const { t } = useTranslation()

    return (
        <div style={{ marginTop: 30, marginBottom: 30 }}>
            <Typography color='primary' variant='h5'>{t('item')} {number}</Typography>
            <Divider style={{ marginBottom: 15 }} />

            <Grid container spacing={1}>
                <Grid container item sm={12} md={6} spacing={1}>
                    <Grid item md={3} sm={6} xs={6}>
                        <Detail property={t('material_number')} value={row.material} />
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Detail property={t('lot_number')} value={row.batch} />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Detail property={t('description')} value={row.description} />
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Detail property={t('date')} value={chain(row.action).map(i => getDate(i.invoiceDate, language) || '').uniq().value()} />
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Detail property={t('invoice')} value={chain(row.action).map(i => i.invoiceNumber).uniq().value()} />
                    </Grid>
                </Grid>

                <Grid container item sm={12} md={6} spacing={1}>
                    <Grid item lg={6} sm={12} xs={12}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column-reverse' }}>
                            <IncrementingNumberInput
                                style={{ width: '100%' }}
                                size='small'
                                label={t('quantity')}
                                value={row.quantity}
                                defaultValue={0}
                                max={row.maxQuantity}
                                // @ts-ignore
                                onBlur={e => !e.currentTarget.contains(e.relatedTarget) && dispatch({ type: 'ChangeQuantity', material: row.material, batch: row.batch, quantity: row.quantity, allowDelete: true })}
                                onChange={(q) => dispatch({ type: 'ChangeQuantity', material: row.material, batch: row.batch, quantity: q, allowDelete: false })}
                            />
                        </div>
                    </Grid>
                    <Grid item lg={6} sm={12} xs={12}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column-reverse' }}>
                            <ReturnReasonSelector
                                label={t('return_reason')}
                                value={row.reason}
                                onChange={e => dispatch({ type: 'UpdateInvoiceReturnReason', material: row.material, batch: row.batch, reason: e.target.value as string })}
                            />
                        </div>
                    </Grid>

                    <Grid item lg={6} sm={12} xs={12}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column-reverse' }}>
                            <FormControl style={{ width: '100%' }}>
                                <TextField
                                    variant='outlined'
                                    size='small'
                                    label={t('po_reference')}
                                    error={(row.poref?.length || 0) > 35}
                                    value={row.poref}
                                    onChange={e => dispatch({ type: 'UpdateInvoicePORef', material: row.material, batch: row.batch, poref: e.target.value as string })}
                                />
                                {(row.poref?.length || 0) > 35 && <span style={{ color: 'red', marginTop: '.3rem', fontSize: '.75rem' }}>Invalid PO/Ref, exceeds 35 characters</span>}
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item lg={6} sm={12} xs={12}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column-reverse' }}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                style={{ width: '100%', height: 40 }}
                                startIcon={<HighlightOffIcon />}
                                onClick={() => dispatch({ type: 'RemoveMaterialBatch', material: row.material, batch: row.batch })}
                            >
                                {t('remove')}
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </div >
    )
}

const ReturnList = () => {
    const { order } = useContext(OrderContext)

    let cnt = 1

    return (
        <ReturnReasonSelectorContextProvider>
            {chain(order).map((row, key) => <ReturnListRow key={key} number={cnt++} row={row} />).value()}
        </ReturnReasonSelectorContextProvider>
    )
}

export default ReturnList
